import { createSelector } from 'reselect';

const locationsSelector = (state) => state.locations;

const cityKeyFromProps = (state, props) => props.cityKey;

const prefectureKeyFromProps = (state, props) => props.prefectureKey;

export const citiesSelector = createSelector(locationsSelector, (locations) =>
  Object.values(locations.cities)
);

export const cityGroupsSelector = createSelector(locationsSelector, (locations) =>
  Object.values(locations.cityGroups)
);

export const citySelector = createSelector(
  locationsSelector,
  cityKeyFromProps,
  (locations, cityKey) => locations.cities[cityKey] || {}
);

export const cityPartSelector = createSelector(
  locationsSelector,
  cityKeyFromProps,
  (locations, cityKey) => {
    const { _id, key, name } = locations.cities[cityKey] ?? {};
    return { _id, key, name };
  }
);

export const geoLocationSelector = createSelector(
  locationsSelector,
  (locations) => locations.geoLocation
);

export const prefectureSelector = createSelector(
  locationsSelector,
  prefectureKeyFromProps,
  (locations, prefectureKey) => locations.prefectures[prefectureKey] || {}
);

export const prefecturePartSelector = createSelector(
  locationsSelector,
  prefectureKeyFromProps,
  (locations, prefectureKey) => {
    const { _id, key, name } = locations.prefectures[prefectureKey] ?? {};
    return { _id, key, name };
  }
);

export const prefecturesSelector = createSelector(locationsSelector, (locations) =>
  Object.values(locations.prefectures)
);
